// src/api/salesRequestApi.js
import api from './api';


export const createSalesRequest = (data) => {
  return api.post('/sales-requests', data);
};


export const getSalesUserRequests = () => {
  return api.get('/sales-requests');
};


export const getHeldOrders = () => {
  return api.get('/sales-requests/held-orders');
};


export const getAllSalesRequests = () => {
  return api.get('/sales-requests/all');
};


export const getHeldSalesRequests = () => {
  return api.get('/sales-requests/held-orders');
};


export const updateSalesRequest = (id, data) => {
  return api.put(`/sales-requests/${id}`, data);
};

export const updateSalesRequestOrderDate = (id, orderDate) => {
  return api.patch(`/sales-requests/${id}/order-date`, { orderDate });
};


export const deleteSalesRequest = (id) => {
  return api.delete(`/sales-requests/${id}`);
};


export const releaseHeldOrder = (id) => {
  return api.post(`/sales-requests/held-orders/${id}/release`);
};


export const unholdHeldOrder = (id) => {
  return api.post(`/sales-requests/held-orders/${id}/unhold`);
};


export const cancelHeldOrder = (id, data) => {
  return api.post(`/sales-requests/held-orders/${id}/cancel`, data);
};

export const approveDiscount = (id, action) => {
  return api.patch(`/sales-requests/${id}/discount`, { action });
};


